{
  "play": "Воспроизвести",
  "pause": "Остановить",
  "mute": "Отключить звук",
  "unmute": "Включить звук"
}
